// Salesforce MIAW (Messaging for In-App & Web) custom-client config.
// Mirrors the const block in ../SalesforceChat.js; kept as plain consts for now
// (like SalesforceChat.js). Move to ENV.js/rooster.js if we need per-env values.
//
// esDeveloperName is the "Custom Client" (deploymentType=api) Embedded Service
// deployment — NOT the widget deployment ('Agentforce_Service_Deployment', type
// web), which doesn't expose the MIAW REST/SSE surface. The deployment must be
// PUBLISHED in SF Setup for the token endpoint to work.

export const MIAW_CONFIG = {
	orgId: '00Dj0000001rkAe',
	esDeveloperName: 'Sparkie_Embedded_TouchSource_AI_Assistant',
	scrt2URL: 'https://touchsource.my.salesforce-scrt.com',
	// Client capabilities version + platform sent on the token request.
	capabilitiesVersion: '1',
	platform: 'Web',
	// Authenticated flow (stable identity → conversations persist across sessions).
	// Requires the deployment's SF "User Verification" to be configured with our
	// public key + iss/aud, and bronco's SPARKIE_JWT_PRIVATE_KEY set. Flip to true
	// once that's in place; until then we use the unauthenticated flow.
	authenticated: true,
};

// Channel Variable Names configured on the deployment's Parameter Mappings.
// Names mirror today's hidden pre-chat fields so the Agentforce prompt config
// doesn't have to change. The agent must be configured to READ each one.
export const MIAW_CHANNEL_VARS = {
	firstName: 'customerFirstName',
	lastName: 'customerLastName',
	email: 'customerEmail',
};
